import { Injectable } from '@angular/core';
import { environment } from '../../../environment/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {

  baseUrl = environment.baseUrl;

  constructor(private httpService: HttpClient) { }

  getAllPayments(params: any) {
    return this.httpService.get(`${this.baseUrl}payments/listPaymentHistory` , {params});
  }

  refundPayment(data: any) {
    return this.httpService.post(`${this.baseUrl}payments/refundPayment`, data);
  }

  buyPackage(data: any) {
    return this.httpService.post(`${this.baseUrl}payments/addPackageToUser`, data);
  }

  exportPaymentsReports(data: any) {
    return this.httpService.get(`${this.baseUrl}payments/exportToCSV`, {params: data , responseType: 'blob'});
  }

  // Add these methods for online payment processing
  addToOrder(packageId: number, customerId: number) {
    return this.httpService.post(`${this.baseUrl}payments/addToOrder`, {
      package_id: packageId,
      customer_user_id: customerId
    });
  }

  processCharge(cartUuid: string, tokenId: string) {
    return this.httpService.post(`${this.baseUrl}payments/charge`, {
      cart_uuid: cartUuid,
      token_id: tokenId
    });
  }

  verifyPayment(paymentUuid: string) {
    return this.httpService.post(`${this.baseUrl}payments/verifyPayment`, {
      payment_uuid: paymentUuid
    });
  }


  checkPaymentStatus(paymentUuid: string) {
    return this.httpService.post(`${this.baseUrl}payments/checkPaymentStatus`, {
      payment_uuid: paymentUuid
    });
  }

  // Add new method for sending email refund form
  sendEmailRefundForm(body: any): Observable<any> {
    return this.httpService.post(`${this.baseUrl}payments/sendEmailRefundFormEmail`, body);
  }
}
